if (!window.FlikEnv || typeof window.FlikEnv != "object") {
  console.error("Flik env was not created");
}

var CHECKOUT_CANCEL = "/cart";
var CHECKOUT_FAIL = "/cart?status=fail";
var CHECKOUT_ICON =
  "https://cdn.shopify.com/s/files/1/0617/1633/2785/t/16/assets/flik-grey.png";
var CREATE_ORDER_ENDPOINT = "/api/cart";
var CREATE_FILK_ORDER = "/api/orders/create";
var CREATE_FILK_BUYNOW_ORDER = "/api/orders/buynow";
var SUCCESS_FILK_ORDER = "/api/orders/success";
var FLIK_PRODUCT = window.FLIK_PRODUCT || {};
var PREVIEW_THEME = Boolean(get_cookie("preview_theme")) || false;

if (PREVIEW_THEME) {
  console.log("window.FlikEnv:", window.FlikEnv);
}

var flikCheckoutButtonHTML = `
    <div class="flik-checkout-button-wrapper">
        <button type="button" class="flik-checkout" role="button">
            <span>
                <img src="${CHECKOUT_ICON}" alt="Checkout icon">
            </span>
            <span class="flik-checkout-button-label">1-CLICK CHECKOUT</span>
        </button>
    </div>
`;

var LOADING_OVERLAY_HTML = `
    <div class="flik-overlay">
        <div class="flik-loader">
            <div class="flik-dot"></div>
            <div class="flik-dot"></div>
            <div class="flik-dot"></div>
            <div class="flik-dot"></div>
            <div class="flik-dot"></div>
            <div class="flik-dot"></div>
            <div class="flik-dot"></div>
            <div class="flik-dot"></div>
        </div>
        <div class="flik-overlay-content">Your order's being processed.</div>
        <div class="flik-create-cart--stuck"></div>
    </div>
`;

var CART = {
  get: "/cart.js",
  clear: "/cart/clear",
};

function getQueryParam() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return Object.fromEntries(urlSearchParams.entries());
}

// fetch cart and make cart_items ready for FLICK order generate
async function getCart() {
  var response = await fetch(CART.get, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.json();
}

async function resetCart() {
  await fetch(`${window.location.origin}/cart.js`)
    .then(response => {
      return response.json();
    })
    .then(async data => {
      var nullHash = {};
      for ([key, value] of Object.entries(data.attributes)) {    
          nullHash[key] = null;
      }
      await fetch(`${window.location.origin}/cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({attributes:nullHash, note: null})
      }).then(async (result) => {
        console.log("result", result)
      })
    })
}

async function createFlikOrder(cart) {
  var response = await fetch(FlikEnv.SERVER_URL + CREATE_FILK_ORDER, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      cart: cart,
      store_domain: FlikEnv.STORE_HANDLE,
      store_url: FlikEnv.STORE_BASE_URL,
      order_success_endpoint: FlikEnv.STORE_BASE_URL + FlikEnv.CHECKOUT_SUCCESS,
      order_fail_endpoint: FlikEnv.STORE_BASE_URL + CHECKOUT_FAIL,
      order_cancel_endpoint: FlikEnv.STORE_BASE_URL + CHECKOUT_CANCEL,
    }),
  });
  return response.json();
}

async function fetchCustomAttribute(elm) {
  const getClass = elm.target.closest(".fliK-checkout-block-cart")
  if(getClass.classList.contains("flik-continue-page")) {
    let id = []
    $(".added").each(function(){
      id.push($(this).data("id"))
    })
    let items = []
    for(let i=0;i<id.length;i++) {
      items.push({
        id: id[i],
        quantity: 1,
        properties: {
          'type': 'Add-ons'
        }
      })
    }
    
    let formData = {
      items
    };
    console.log(formData, 'items Add Ons')
    if(items.length > 0) {
      await fetch(`${window.location.origin}/cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(async (response) => {
        await sendCustomAttribute()
      })
    } else {
      await sendCustomAttribute()
    }
  } else {
    await sendCustomAttribute()
  }
}

async function sendCustomAttribute() {
  let formData2 = {
    attributes: {
      'Tanggal Pengiriman': $("#delivery_date").val(),
      'Waktu Pengiriman': $("#delivery_time").val(),
      'Nama Kartu Penerima': $("#delivery_card_recipient").val(),
      'Kartu Ucapan': $("#delivery_card").val(),
      'Nama Kartu Pengirim': $("#delivery_card_sender").val(),
      'Foto': $("#foto").val()
    },
    note: $("[name=note]").val()
  };
  await fetch(`${window.location.origin}/cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData2)
  })
  .then(async (result) => {
    await fetch(`${window.location.origin}/cart.js`)
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data, 'NEW CART')
      })
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

async function FlikBuyNowOrder(item) {
  await fetchCustomAttribute();
  var response = await fetch(FlikEnv.SERVER_URL + CREATE_FILK_BUYNOW_ORDER, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      item: item,
      store_domain: FlikEnv.STORE_HANDLE,
      store_url: FlikEnv.STORE_BASE_URL,
      order_success_endpoint: FlikEnv.STORE_BASE_URL + FlikEnv.CHECKOUT_SUCCESS,
      order_fail_endpoint: FlikEnv.STORE_BASE_URL + CHECKOUT_FAIL,
      order_cancel_endpoint: FlikEnv.STORE_BASE_URL + CHECKOUT_CANCEL,
    }),
  }).then(() => {
    resetCart()
  });
  return response.json();
}

//inject CSS
function flikLoadScript(url, callback) {
  var script = document.createElement("link");
  script.rel = "stylesheet";
  if (script.readyState) {
    // only required for IE <9
    script.onreadystatechange = function () {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = function () {
      callback();
    };
  }
  script.href = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}

function isInViewport(el) {
  if (el == null) {
    return;
  }
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function redirect(endpoint) {
  window.location.href = endpoint;
}

function IsFlikButtonLoaded() {
  return (
    Array.from(document.getElementsByClassName("fliK-checkout-block"))
      .length !== 0
  );
}

function flikLoadingOverlay(state) {
  if (state === "hide") {
    document.querySelector(".flik-overlay").remove();
    document.querySelector("html").classList.remove("flik-overlay-scroll");
  } else {
    appendHTML(document.body, LOADING_OVERLAY_HTML, "beforeend");
    document.querySelector("html").classList.add("flik-overlay-scroll");
  }
}

function appendHTML(element, html, type = "afterBegin") {
  element.insertAdjacentHTML(type, html);
}

function generateCartFLIK(elm) {
  flikLoadingOverlay("show");
  createCart(elm);
}

function flikInitCarts() {
  console.log("called")
  const elms = document.querySelectorAll(`.fliK-checkout-block-cart`)
  if(elms.length > 0) {
    elms.forEach((elm) => {
      elm.removeEventListener("click", generateCartFLIK, false)
      elm.addEventListener("click", generateCartFLIK, false)
    })
  }
}

function flikInitQuickAdd() {
  const checkoutWrapper = document.querySelector(`.fliK-checkout-block-quick-add`)
  const checkoutBtn = document.querySelector(`.flik-checkout`)
  if (checkoutWrapper && checkoutBtn) {
    checkoutWrapper.addEventListener("click", async function (event) {
      if (this.dataset.actionType === "buy-now") {
        await getProductByHandler(this.dataset.flikHandle, this.dataset.variant)
      }
    }, false);
  }
}

function flikInitDetail() {
  const checkoutWrapper = document.querySelector(`.fliK-checkout-block-detail`)
  const checkoutBtn = document.querySelector(`.flik-checkout`)
  if (checkoutWrapper && checkoutBtn) {
    checkoutWrapper.addEventListener("click", async function (event) {
      if (this.dataset.actionType === "buy-now") {
        await getProductByHandler(this.dataset.flikHandle, this.dataset.variant)
      }
    }, false);
  }
}

async function generateBuyNow() {
  if (this.dataset.actionType === "buy-now") {
    await getProductByHandler(this.dataset.flikHandle, this.dataset.variant)
  }
}

function flikInitDetails() {
  const elms = document.querySelectorAll(`.fliK-checkout-block-detail`)
  if(elms.length > 0) {
    elms.forEach((elm) => {
      elm.removeEventListener("click", generateBuyNow, false)
      elm.addEventListener("click", generateBuyNow, false)
    })
  }
}

async function createCart(elm) {
  await fetchCustomAttribute(elm)
  console.log("order is being created via cart checkout");
  var cart = await getCart();
  setStatus();
  var order = await createFlikOrder(cart);
  await resetCart();
  if (PREVIEW_THEME) console.log("createFlikOrder:", order);
  if (order && order.cart_url) {
    const url = flikSetGA(order.cart_url)
    document.querySelector(".flik-overlay-content").textContent =
      "Almost done!";
    appendHTML(
      document.querySelector(".flik-create-cart--stuck"),
      `<div class="flik-checkout-stuck">
                <a class="flik-btn-plain" href="${url}">Click here</a> if you are stuck
            </div>`
    );
    redirect(url);
    TrackIfStuck(url);
  } else {
    flikLoadingOverlay("hide");
  }
}

function FlikPrice(amount) {
  if (!amount || isNaN(amount)) {
    return 0;
  }
  if (typeof amount === "string") {
    try {
      amount = amount.replace(".", "");
    } catch (e) {}
  }
  if (amount && !isNaN(amount)) {
    try {
      amount = Number(amount) / 100;
    } catch (e) {}
  }
  return amount;
}

function SelectedOrFirstVariant(id) {
  var variant = null;
  if (FLIK_PRODUCT) {
    if (FLIK_PRODUCT.variants.findIndex((x) => x.id == id) > -1) {
      variant =
        FLIK_PRODUCT.variants[
          FLIK_PRODUCT.variants.findIndex((x) => x.id == id)
        ];
    }
  }
  return variant;
}

function isVariantAvailable(variant) {
  var a = false;
  if (variant.available && typeof variant.available === "boolean") {
    a = variant.available;
  } else if (variant && typeof variant === "object") {
    if (
      variant.inventory_quantity > 0 ||
      variant.inventory_policy == "continue"
    ) {
      a = true;
    } else if (!variant.inventory_management) {
      a = true;
    }
  }
  return a;
}

function setStatus() {
  setTimeout(() => {
    try {
      document.querySelector(".flik-overlay-content").textContent =
        "Checking inventories";
    } catch (e) {}
  }, 2000);
  setTimeout(() => {
    try {
      document.querySelector(".flik-overlay-content").textContent =
        "Almost done!";
    } catch (e) {}
  }, 10000);
  setTimeout(() => {
    try {
      flikLoadingOverlay("hide");
    } catch (e) {}
  }, 60000);
}

function TrackIfStuck(cart_url) {
  if (cart_url) {
    var i = 0;
    // recursive function to force user to go to checkout. Use recursive function to prevent infinite loop
    function _red() {
      i++;
      setTimeout(() => {
        redirect(cart_url);
        if (i < 20) {
          _red();
        }
      }, 1500);
    }
    _red();
  }
}

function initFlik() {
  console.log("initFlik:");
  if (!IsFlikButtonLoaded()) {
    console.error("flik button wrapper not found");
  }
  flikInitHTML();
}

function get_cookie(cookie_name) {
  const value = "; " + document.cookie;
  const parts = value.split("; " + cookie_name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
}

async function getProductByHandler(handle, vid) {
  flikLoadingOverlay("show");
  await fetch(`${window.location.origin}/products/${handle}.json`)
  .then(async (response) => {
    const data = await response.json()
    FLIK_PRODUCT = data.product

    const selected_variant = FLIK_PRODUCT.variants.find((variant) => String(variant.id) === String(vid))
    if (PREVIEW_THEME) console.log("selected_variant", selected_variant)

    const dynamic_attributes = {
      option1: selected_variant.option1,
      option2: selected_variant.option2 === null ? undefined : selected_variant.option2,
      option3: selected_variant.option3 === null ? undefined : selected_variant.option3
    };

    var variant_qty_selector = document.querySelector('[name="quantity"]') || document.querySelector('[data-popout-toggle-text]');
    var variant_qty = 1;
    if (variant_qty_selector && (variant_qty_selector.value || variant_qty_selector.innerText)) {
      variant_qty = parseInt(variant_qty_selector.value) || parseInt(variant_qty_selector.innerText);
    }
    
    let imgUrl = FLIK_PRODUCT.image.src;
    if (PREVIEW_THEME) console.log("imgUrl:", imgUrl);

    const buy_now_product = [
      {
        product_id: String(FLIK_PRODUCT.id),
        item_id: String(vid),
        name: String(FLIK_PRODUCT.title),
        qty: variant_qty,
        dynamic_attributes: dynamic_attributes,
        weight: selected_variant.weight || 1,
        image_url: imgUrl,
        detail_url:
          FlikEnv.STORE_BASE_URL + "/products/" + FLIK_PRODUCT.handle,
        sell_price: FlikPrice(selected_variant.price),
        volume: {
          length: 5,
          width: 10,
          height: 5,
        },
      },
    ];
    if (PREVIEW_THEME) console.log("buy_now_product", buy_now_product);
    var order = await FlikBuyNowOrder(buy_now_product);
    if (PREVIEW_THEME) console.log("FlikBuyNowOrder : ", order);
    if (order && order.cart_url) {
      const url = flikSetGA(order.cart_url)
      document.querySelector(".flik-overlay-content").textContent =
        "Almost done!";
      appendHTML(
        document.querySelector(".flik-create-cart--stuck"),
        `<div class="flik-checkout-stuck">
                        <a class="flik-btn-plain" href="${url}">Click here</a> if you are stuck
                    </div>`
      );
      redirect(url);
      TrackIfStuck(url);
    } else {
      flikLoadingOverlay("hide");
    }
  })
}

async function getProductByEnv(vid) {
  flikLoadingOverlay("show");

  const selected_variant = FLIK_PRODUCT.variants.find((variant) => String(variant.id) === String(vid))
  if (PREVIEW_THEME) console.log("selected_variant", selected_variant)

  const dynamic_attributes = {
      option1: selected_variant.option1,
      option2: selected_variant.option2 === null ? undefined : selected_variant.option2,
      option3: selected_variant.option3 === null ? undefined : selected_variant.option3
    };
  
  let imgUrl = FLIK_PRODUCT.image.src;
  if (PREVIEW_THEME) console.log("imgUrl:", imgUrl);

  const buy_now_product = [
    {
      product_id: String(FLIK_PRODUCT.id),
      item_id: String(vid),
      name: String(FLIK_PRODUCT.title),
      qty: 1,
      dynamic_attributes: dynamic_attributes,
      weight: selected_variant.weight || 1,
      image_url: imgUrl,
      detail_url:
        FlikEnv.STORE_BASE_URL + "/products/" + FLIK_PRODUCT.handle,
      sell_price: FlikPrice(selected_variant.price),
      volume: {
        length: 5,
        width: 10,
        height: 5,
      },
    },
  ];
  if (PREVIEW_THEME) console.log("buy_now_product", buy_now_product);
  var order = await FlikBuyNowOrder(buy_now_product);
  if (PREVIEW_THEME) console.log("FlikBuyNowOrder : ", order);
  if (order && order.cart_url) {
    const url = flikSetGA(order.cart_url)
    document.querySelector(".flik-overlay-content").textContent =
      "Almost done!";
    appendHTML(
      document.querySelector(".flik-create-cart--stuck"),
      `<div class="flik-checkout-stuck">
                      <a class="flik-btn-plain" href="${url}">Click here</a> if you are stuck
                  </div>`
    );
    redirect(url);
    TrackIfStuck(url);
  } else {
    flikLoadingOverlay("hide");
  }
}

function flikVariantChange(selector, variant) {
  const elm = document.querySelector(selector)
  const pEmpty = document.querySelector(`.fliK-checkout-stock-empty`)

  if(elm && pEmpty) {
    elm.dataset.variant = variant.id

    if(!variant.available){
      elm.classList.add("isHidden")
      pEmpty.classList.remove("isHidden")
    } else {
      elm.classList.remove("isHidden")
      pEmpty.classList.add("isHidden")
    }
  }
}

function flikQuickAddVariantChange(root, selector, variant) {
  const elm = root.querySelector(selector)
  const pEmpty = root.querySelector(`.fliK-checkout-stock-empty`)

  if(elm && pEmpty) {
    elm.dataset.variant = variant.id

    if(!variant.available){
      elm.classList.add("isHidden")
      pEmpty.classList.remove("isHidden")
    } else {
      elm.classList.remove("isHidden")
      pEmpty.classList.add("isHidden")
    }
  }
}

function flikSetGA(url) {
  const cookiesGA = get_cookie(`_ga`)
  if(cookiesGA) {
    return `${url}?_gl=${cookiesGA}&back=${window.location.href}`;
  }
  return `${url}?back=${window.location.href}`
}

flikInitCarts();